
import { useEffect, useState } from "react";

import { FilledButton, OutlinedButton } from "../../common/Button";
import Lightbox from "../../common/Lightbox";
import useDisplayNotifications from "../../../hooks/useDisplayNotifications";
import { DisplayNotificationType } from "../../../models/DisplayNotification";
import useMyProjects from "../../../hooks/useMyProjects";


import { ITask } from "../../../data_models/task";
import { IProject } from "../../../data_models/project";
import useProjects from "../../../hooks/useProjects";


interface StartProjectSelfManagedLightboxProps {
    onClose: () => void;
    project: IProject;
    onProjectUpdate: (project: IProject) => void;
    onTasksUpdate: (tasks: ITask[]) => void;
}

const StartProjectSelfManagedLightbox: React.FC<StartProjectSelfManagedLightboxProps> = ({ onClose, project, onProjectUpdate, onTasksUpdate }) => {

    const [loading, setLoading] = useState(false);

    const { startProjectSelfManaged } = useProjects();
    const { addSuccessNotification } = useDisplayNotifications();

    const onStartProjectSelfManaged = async () => {
        setLoading(true);
        try {
            const { project: updatedProject, tasks } = await startProjectSelfManaged(project._id!);
            if (updatedProject) {
                onProjectUpdate(updatedProject);
            }
            if (tasks) {
                onTasksUpdate(tasks);
            }
            addSuccessNotification("Project started successfully");
        } catch (error: any) {
            // addErrorNotification(error.message);
        }
        setLoading(false);
        onClose();
    }


    return (
        <Lightbox
            header="Start Project Self Managed"
            onClose={onClose}
            onCancel={onClose}
            onConfirm={onStartProjectSelfManaged}
            confirmText="Start Project"
            loadingConfirm={loading}
            content={
                <div className="flex flex-col items-start" >
                    <p>Get started by hiring talent for your tasks and managing them your way.
                        Find the right people, get things done—and if it ever feels like too much,
                        you can bring in a project manager anytime!</p>
                    {!project._roadmapVerifiedAt && <p className="mt-5 font-bold">Pro tip</p>}
                    {!project._roadmapVerifiedAt && <p className="text-neutral-700">Things go much smoother when your project roadmap is realistic and solid from the start.</p>}
                </div>
            }

        />

    );
}

export default StartProjectSelfManagedLightbox;